import profile from '../assets/profile.webp';
import circle from '../assets/circle.svg';

const exportedObject = {
  profile,
  circle,
};
export default exportedObject;
